export default {
    apiEndpoint: function() { return global.OraWidgets.Options.apiEndpoint; }
};